/* eslint-disable indent */
/* eslint-disable @typescript-eslint/indent */
import { Crate } from '@piwikpro/platform';
import LicenseKeeperCrate from '@piwikpro/license-keeper-crate';
import AuthCrate from '@piwikpro/auth-crate';
import { RouterCrate } from '@piwikpro/router-crate/RouterCrate';
import ChangePlanOverlay from './components/ChangePlanOverlay/ChangePlanOverlay';
import { MarketingService } from './MarketingService';
import { BillingService } from './BillingService';
import paymentsReducer from './redux';
import Billing from './components/Billing/Billing';
import ScheduledActionInformation from './components/ScheduledActionInformation';

@Crate({
  name: 'MarketingCrate',
  imports: [
    AuthCrate,
    LicenseKeeperCrate,
    RouterCrate
  ],
  services: [
    { name: 'marketingService', provide: MarketingService },
    { name: 'billingService', provide: BillingService },
  ],
  components: [
    { name: 'ChangePlanOverlay', provide: ChangePlanOverlay },
    { name: 'Billing', provide: Billing },
    { name: "ScheduledActionInformation", provide: ScheduledActionInformation }
  ],
  reducers: {
    payments: paymentsReducer,
  },
  bootstrap: ChangePlanOverlay,
})

export class MarketingCrate { }
